/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetAccessRequestResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetAccessRequestResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { ApproveRequestBuilderRequestsMetadata, type ApproveRequestBuilder } from './approve/index.js';
// @ts-ignore
import { DeclineRequestBuilderRequestsMetadata, type DeclineRequestBuilder } from './decline/index.js';
// @ts-ignore
import { ResearchRequestBuilderRequestsMetadata, type ResearchRequestBuilder } from './research/index.js';
// @ts-ignore
import { RestoreRequestBuilderRequestsMetadata, type RestoreRequestBuilder } from './restore/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/access-requests/{accessRequestId}
 */
export interface WithAccessRequestItemRequestBuilder extends BaseRequestBuilder<WithAccessRequestItemRequestBuilder> {
    /**
     * The approve property
     */
    get approve(): ApproveRequestBuilder;
    /**
     * The decline property
     */
    get decline(): DeclineRequestBuilder;
    /**
     * The research property
     */
    get research(): ResearchRequestBuilder;
    /**
     * The restore property
     */
    get restore(): RestoreRequestBuilder;
    /**
     * Gets a specific access request by ID, together with the customer it was approved into (if any) and what the platform already knows about the requester's email address — whether an account exists and which customers it can already shop for in this organization.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetAccessRequestResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithAccessRequestItemRequestBuilderGetQueryParameters> | undefined) : Promise<GetAccessRequestResponse | undefined>;
    /**
     * Gets a specific access request by ID, together with the customer it was approved into (if any) and what the platform already knows about the requester's email address — whether an account exists and which customers it can already shop for in this organization.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithAccessRequestItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Gets a specific access request by ID, together with the customer it was approved into (if any) and what the platform already knows about the requester's email address — whether an account exists and which customers it can already shop for in this organization.
 */
export interface WithAccessRequestItemRequestBuilderGetQueryParameters {
    /**
     * The identity-provider organization code from the caller's token claims. Optional: only used toreport whether the requester's account is already a member of the organization.
     */
    orgCode?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithAccessRequestItemRequestBuilderUriTemplate = "{+baseurl}/api/organizations/access-requests/{accessRequestId}{?orgCode*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithAccessRequestItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithAccessRequestItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    approve: {
        requestsMetadata: ApproveRequestBuilderRequestsMetadata,
    },
    decline: {
        requestsMetadata: DeclineRequestBuilderRequestsMetadata,
    },
    research: {
        requestsMetadata: ResearchRequestBuilderRequestsMetadata,
    },
    restore: {
        requestsMetadata: RestoreRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithAccessRequestItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithAccessRequestItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetAccessRequestResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
